import React, { useRef, useState } from 'react'
import {
  AppBar,
  Toolbar
} from '@mui/material'
import { useFormFactor } from '../../hooks'
import { useStyles } from './style'
import { PaidConsumerMobileDrawer } from './navigation/paid-consumer-mobile-drawer'
import { PaidConsumerProfileMenu } from './navigation/paid-consumer-profile-menu'
import { MobileNavigation, DesktopNavigation } from './navigation'

const AppToolbarPaidConsumer = () => {
  const classes = useStyles()
  const { isMobile, isSmallTablet, isLargeTablet } = useFormFactor()
  const isTablet = isSmallTablet || isLargeTablet
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null)
  const [searchExpanded, setSearchExpanded] = useState(false)
  const appBarRef = useRef(null)

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor(event.currentTarget)
  }

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null)
  }

  const handleSearchToggle = () => {
    setSearchExpanded(!searchExpanded)
  }

  return (
    <>
      <AppBar
        ref={appBarRef}
        position='sticky'
        className={classes.appBar}
        elevation={0}
      >
        <Toolbar className={classes.toolbar} disableGutters>
          {isMobile || isTablet
            ? (
              <MobileNavigation
                onMenuToggle={handleMobileMenuToggle}
                onProfileMenuOpen={handleProfileMenuOpen}
                onSearchToggle={handleSearchToggle}
                searchExpanded={searchExpanded}
                isTablet={isTablet}
              />
              )
            : (
              <DesktopNavigation
                onProfileMenuOpen={handleProfileMenuOpen}
              />
              )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <PaidConsumerMobileDrawer
        open={mobileMenuOpen}
        onClose={handleMobileMenuToggle}
      />

      {/* Profile Menu */}
      <PaidConsumerProfileMenu
        anchorEl={profileMenuAnchor}
        open={Boolean(profileMenuAnchor)}
        onClose={handleProfileMenuClose}
      />
    </>
  )
}

export default AppToolbarPaidConsumer
